// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"519":"2bb6dc48","523":"9458e3c9","779":"ac478d7a","971":"e2e4ec71"}[chunkId] + ".css";
};